var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{style:({ left: '50%', transform: 'translateX(-50%)' }),attrs:{"timeout":_vm.timeout,"color":_vm.color,"rounded":"pill","bottom":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._v(" "+_vm._s(_vm.message === 'Le groupe est bien ajouté' ? '✅' : '❌')+" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }